//client/src/utils/cepService.js
import axios from 'axios';

// Normaliza a resposta da BrasilAPI
const normalizeBrasilAPI = (data) => ({
    cep: data.cep,
    logradouro: data.street,
    bairro: data.neighborhood,
    localidade: data.city,
    uf: data.state
});

// Normaliza a resposta da ViaCEP
const normalizeViaCEP = (data) => ({
    cep: data.cep.replace('-', ''),
    logradouro: data.logradouro,
    bairro: data.bairro,
    localidade: data.localidade,
    uf: data.uf
});

// Normaliza a resposta da AwesomeAPI
const normalizeAwesomeAPI = (data) => ({
    cep: data.cep,
    logradouro: data.address,
    bairro: data.district,
    localidade: data.city,
    uf: data.state
});

/**
 * Busca um CEP usando uma sequência de APIs como fallback.
 * @param {string} cep - O CEP a ser consultado (apenas números).
 * @returns {object|null} - Objeto com os dados do endereço ou null se não encontrado.
 */
export const lookupCep = async (cep) => {
    const sanitizedCep = cep.replace(/\D/g, '');
    if (sanitizedCep.length !== 8) {
        throw new Error('CEP inválido. Deve conter 8 dígitos.');
    }

    try {
        // 1ª Tentativa: BrasilAPI (mais completa)
        const brasilApiResponse = await axios.get(`https://brasilapi.com.br/api/cep/v2/${sanitizedCep}`);
        return normalizeBrasilAPI(brasilApiResponse.data);
    } catch (error) {
        console.warn('BrasilAPI falhou, tentando ViaCEP...', error);
        try {
            // 2ª Tentativa: ViaCEP
            const viaCepResponse = await axios.get(`https://viacep.com.br/ws/${sanitizedCep}/json/`);
            if (viaCepResponse.data.erro) throw new Error('CEP não encontrado na ViaCEP');
            return normalizeViaCEP(viaCepResponse.data);
        } catch (error2) {
            console.warn('ViaCEP falhou, tentando AwesomeAPI...', error2);
            try {
                // 3ª Tentativa: AwesomeAPI
                const awesomeApiResponse = await axios.get(`https://www.awesomeapi.com.br/json/cep/${sanitizedCep}`);
                return normalizeAwesomeAPI(awesomeApiResponse.data);
            } catch (error3) {
                console.error('Todas as APIs de CEP falharam.', error3);
                throw new Error('Não foi possível encontrar o CEP. Verifique o número e tente novamente.');
            }
        }
    }
};